
























































































































































































import { Component, Vue } from "vue-property-decorator";
import { storeComplaintResponse } from "@/store/modules/ComplaintResponseStore";
import ComplaintResponseSvc from "@/services/ComplaintResponseService";
import moment from "moment";

@Component
export default class ComplaintResponseMonthlyReport extends Vue {
  storeModule = storeComplaintResponse;
  tahun = moment().year();
  bulan = moment().month() + 1;
  catatanKaUnit = "";
  catatanKomiteMutu = "";
  password = "";
  submitting = false;

  bulanOptions = [
    { text: "Januari", value: 1 }, { text: "Februari", value: 2 }, { text: "Maret", value: 3 },
    { text: "April", value: 4 }, { text: "Mei", value: 5 }, { text: "Juni", value: 6 },
    { text: "Juli", value: 7 }, { text: "Agustus", value: 8 }, { text: "September", value: 9 },
    { text: "Oktober", value: 10 }, { text: "November", value: 11 }, { text: "Desember", value: 12 },
  ];

  kasusHeaders = [
    { text: "Tgl", value: "tanggal_terima", width: "100px" },
    { text: "Nomor", value: "nomor_event" },
    { text: "Grading", value: "grading_final", align: "center" },
    { text: "Pelapor", value: "nama_pelapor" },
    { text: "Unit", value: "unit_nama" },
    { text: "RTL", value: "rtl_korektif_jangka_pendek" },
    { text: "Status RTL", value: "rtl_status" },
  ];

  get tahunOptions() {
    const now = moment().year();
    const out: number[] = [];
    for (let t = now; t >= now - 3; t--) out.push(t);
    return out;
  }

  get report() {
    return this.storeModule.monthlyReport;
  }

  get events() {
    return this.storeModule.monthlyEvents;
  }

  get tidakTercapaiEvents() {
    return this.events.filter((e: any) => e.status_penanganan === "tidak_tercapai");
  }

  get denominator() {
    if (!this.report) return 0;
    return (this.report.total_tercapai || 0) + (this.report.total_tidak_tercapai || 0);
  }

  get capaianClass() {
    if (!this.report) return "";
    return this.report.status_target === "tercapai" ? "green--text" : "red--text";
  }

  get gradingRows() {
    if (!this.report) return [];
    return [
      {
        kode: "merah",
        total: this.report.total_merah,
        tercapai: this.report.total_merah_tercapai,
        capaian: this.report.capaian_merah_pct,
      },
      {
        kode: "kuning",
        total: this.report.total_kuning,
        tercapai: this.report.total_kuning_tercapai,
        capaian: this.report.capaian_kuning_pct,
      },
      {
        kode: "hijau",
        total: this.report.total_hijau,
        tercapai: this.report.total_hijau_tercapai,
        capaian: this.report.capaian_hijau_pct,
      },
    ];
  }

  mounted() {
    this.loadReport();
  }

  loadReport() {
    this.storeModule.loadMonthly({ tahun: this.tahun, bulan: this.bulan });
  }

  async triggerAggregate() {
    await ComplaintResponseSvc.triggerAggregate(this.tahun, this.bulan);
    setTimeout(() => this.loadReport(), 800);
  }

  async finalize() {
    this.submitting = true;
    try {
      await ComplaintResponseSvc.finalizeMonthly(this.tahun, this.bulan, {
        catatan_ka_unit: this.catatanKaUnit,
        catatan_komite_mutu: this.catatanKomiteMutu,
        password: this.password,
      });
      this.password = "";
      this.loadReport();
    } catch {
      // handled in service
    }
    this.submitting = false;
  }

  printPdf() {
    ComplaintResponseSvc.printMonthlyPdf(this.tahun, this.bulan);
  }

  formatDate(val: string) {
    return val ? moment(val).format("DD/MM/YYYY") : "-";
  }

  gradingColor(val: string) {
    const m: any = { merah: "#D32F2F", kuning: "#F9A825", hijau: "#388E3C" };
    return m[val] || "grey";
  }

  gradingBatas(val: string) {
    const m: any = { merah: "≤ 24 jam", kuning: "≤ 3 hk", hijau: "≤ 7 hk" };
    return m[val] || "-";
  }
}
